import React, { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import { Config } from "../../config";
import { useLocation } from "react-router-dom";

const config = new Config();

interface UseMediaLibraryProps {
  url: any;
  relationFilter?: any;
  isOpen: boolean;
  onClose: () => void;
  onDataSelected: (data: any) => void;
  saveVideo?: (selectedVideo: any) => void;
}

const UseMediaLibrary: React.FC<UseMediaLibraryProps> = ({ url, relationFilter, isOpen, onClose, onDataSelected, saveVideo }) => {
  const [companyCode, setCompanyCode] = useState<string | null>(null);
  const [mediaUrl, setMediaUrl] = useState("");
  var originUrl = config.settings.MediaSiteUrl;
  const location = useLocation();


  useEffect(() => {
    if (window.addEventListener) {
      window.addEventListener("message", onMessage, false);
    }
    function onMessage(event: any) {

      if (event.origin === originUrl) {
        let data = event.data;
        if (data.message === "success") {
          setUploadedData(data);
        } else {
          onClose();
        }
      }
    }
  }, []);

  const setUploadedData = (data: any) => {
    if (data) {
      onDataSelected(data);
    }
    onClose();
  };

  const uploadMedia = () => {
    let clientCode: any =new URLSearchParams(location.search).get("clientCode");
    let r_filters: any = JSON.stringify(relationFilter);
    url = `${originUrl}/openMediaPopup?r_filters=${r_filters}&clientcode=${clientCode}`;
    setMediaUrl(url);
  };

  useEffect(() => {
    uploadMedia();
  }, [companyCode, relationFilter]);

  return (
    <>
      {mediaUrl && (
        <Dialog fullWidth={true} maxWidth={"lg"} open={isOpen} onClose={() => { onClose() }} PaperProps={{ style: { height: "100%" } }}>
          <iframe
            className="iframe-div h-full w-full"
            id="refIframe"
            src={mediaUrl}
            title="Media Library"
          ></iframe>
        </Dialog>
      )}
    </>
  );
};

export default UseMediaLibrary;
